/**
 * Created by mongoose on 8/11/17.
 */
import { MIDDLEWARE_URL as BASE_URL } from "../request";
import constants from "../CRUD/constants";
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../CRUD/utils";

const ModuleDefinition = {
  name: "Forward Reservations",
  entityName: constants.ENTITY.FORWARDING_RESERVATIONS.name,
  restConfig: {
    baseURL: `${BASE_URL}`,
    fetch: {
      url: ({ hotelTicker, reservationId }) =>
        `WitBookerAPI-war/webresources/endpoint/channels/status?propertyTicker=${hotelTicker}&reservationId=${reservationId}`,
      method: "get",
    },
    post: {
      url: "WitBookerAPI-war/webresources/endpoint/channels/notifications",
      method: "post",
    },
    reset: {
      url: "WitBookerAPI-war/webresources/endpoint/channels/notifications/reset",
      method: "post",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "Traducciones",
    widget: "translations",
    entityProperty: "translations",
  },
  fields: {
    list: [
      {
        fieldName: "id",
        displayName: "connection",
      },
      {
        fieldName: "itemId",
        displayName: "item_id",
      },
      {
        fieldName: "creationDate",
        displayName: "creation_date",
      },
      {
        fieldName: "lastExecuteDate",
        displayName: "last_execute_date",
      },
      {
        fieldName: "channel",
        displayName: "channel_manager",
      },
      {
        fieldName: "totalRequestExecuted",
        displayName: "tries",
      },
      {
        fieldName: "transactionStatus",
        displayName: "status",
      },
    ],
    form: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "",
        readOnly: true,
        widget: "autoComplete",
        options: window.wbkPropertyTickers || [
          "mhg_majestic",
          "casabonay.com",
          "hotelvillaflamenca.com",
          "puertopalace.com",
          "massalagros.com",
          "eoh_maspalomas_resort",
          "evokel_bcnsuites",
          "demo_lucic",
          "parkpiolets.com",
        ],
        className: "tickerInput",
        placeholder: "Enter a hotel ticker",
      },
      {
        fieldName: "reservationId",
        displayName: "Id from the reservation (M)",
        widget: "input",
        placeholder: "Enter a reservation id",
      },
    ],
  },
  validation: {
    hotelTicker: {
      type: "String",
      constraints: {},
    },
    reservationId: {
      type: "String",
      constraints: {},
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
